const portfolioSlider = (selector, navSelector) => () => {
    $(selector).slick({
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        fade: true,
        asNavFor: navSelector,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    variableWidth: true,
                    fade: false
                }
            }
        ]
    });

    $(navSelector).slick({
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        asNavFor: selector,
        focusOnSelect: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: "unslick"
            }
        ]
    });
};

export default portfolioSlider;



// WEBPACK FOOTER //
// ./assets/js/modules/portfolio-slider.js